export const testIds = {
  validateSFxButton: 'validate-sfx-button',
};
